import { ImageProps } from "next/image";
import { hero, HeroVariantProps } from "./hero.variants";

export type UseHeroProps = ComponentProps<
  {
    title: string;
    description?: string;
    cta?: {
      title: string;
      href: string;
    };
    image: Pick<ImageProps, "src" | "alt">;
    background?: Pick<ImageProps, "src" | "alt">;
  },
  HeroVariantProps
>;

export const useHero = (props: UseHeroProps) => {
  const { className = "", data } = props;

  const styles = hero();

  return {
    className,
    styles,
    data,
  };
};
